import React from 'react';
import { ErrorMessage, ErrorMessageProps } from 'formik';
import { createUseStyles } from 'react-jss';
import Text from './Text';
import clsx from 'clsx';

export interface FormikErrorMessageProps extends ErrorMessageProps {}

const FormikErrorMessage: React.FC<FormikErrorMessageProps> = (props) => {
  const classes = useStyles();

  return (
    <ErrorMessage
      {...props}
      render={(text) => (
        <Text bold className={clsx('mb-1', classes.message)}>
          {text}
        </Text>
      )}
    />
  );
};

const useStyles = createUseStyles({
  message: {
    color: 'tomato !important',
    textTransform: 'none !important',
  },
});

export default FormikErrorMessage;
